import React from 'react';

const Future = () => {
  return (
    <section id="future" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">Future Innovations</h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto text-lg">
          Expanding our hub with AI-driven outbreak predictions, new modules for Malaria and TB, and broader African collaborations. Stay tuned for more publications and activities.
        </p>
      </div>
    </section>
  );
};

export default Future;